
<template>


<div>


    <section class="full-reset section-gallery-ins">
	
		<article class="container">
			<h2 class="text-center">Programas De Estudio<i class=""></i> &nbsp;</h2>
			<div class="row">
                <div class="col-sm">
                <h1>Primer Año</h1>
                <iframe src="https://drive.google.com/embeddedfolderview?id=1ikb_z2yFeQkZlXwcSza83Kl46anKtLsh#list" width="800" height="600" frameborder="1"></iframe>
				<h1>Segundo Año</h1>
                <iframe src="https://drive.google.com/embeddedfolderview?id=1WQVrtyalSmxSIjdSdd1gN0SADHgmUCHJ#list" width="800" height="600" frameborder="1"></iframe>
                </div>
			</div>
				
		</article>
		<div class="divider-general"></div>
		<!--======================================== Eventos del 2012 ========================================-->
		<article class="container">
			
			<div class="row">
                <div class="col-sm">
                <h1>Tercer Año</h1>
                <iframe src="https://drive.google.com/embeddedfolderview?id=1m3yysmzJdgzRtj6KXVnOUOzGkZfKGVbr" width="800" height="600" frameborder="1"></iframe>
				<h1>Cuarto Año</h1>
                <iframe src="https://drive.google.com/embeddedfolderview?id=1aeGCRMn_3yJ8Hmwtk0DEOF9kDDydM-Yv" width="800" height="600" frameborder="1"></iframe>
				</div>
			</div>
		</article>
		<div class="divider-general"></div>
		<!--======================================== Eventos del 2011 ========================================-->
		<article class="container">			
			<div class="row">
                <div class="col-sm">
                <h1>Quinto Año</h1>
                <iframe src="https://drive.google.com/embeddedfolderview?id=1Lu7n6OQpwop5ALLZZtR789gnmvKyrXq6" width="800" height="600" frameborder="1"></iframe>
				<h1>Sexto Año</h1>
                <iframe src="https://drive.google.com/embeddedfolderview?id=1V-bck_2mr-likqkWFBLCi0jy4P8H7qUK" width="800" height="600" frameborder="1"></iframe>

			</div>	
			</div>
		</article>
    </section>
    </div>
</template>





<script>




export default {
  name: "Programas",
  components: {
   
  }
};

</script>


// WEBPACK FOOTER //
// src/components/Programas.vue